import React from "react"
import { MyIconHelpers } from "@macashipo/mlib"
const MI_Peso = React.lazy(() => import("./Types/peso"))
const List = { peso: MI_Peso }
const MyIconOne = {
  init() {
    MyIconHelpers.addTypesFromListLazy(List)
  },
}

export default MyIconOne
